import React from 'react'
import { PageFirst, PageLast } from '@carbon/icons-react'
import { Button } from '@carbon/react'

const DefaultPageSize = 30

type Props = {
    page: number
    total: number
    onChange: (page: number) => void
    pageSize?: number
}

export default function Pagination(props: Props) {
    const { page, total, onChange, pageSize = DefaultPageSize } = props

    let numPages = Math.ceil(total / pageSize)

    if (total <= pageSize) return null

    return (
        <div className='text-sm my-2 flex items-center'>
            <Button renderIcon={PageFirst} iconDescription='previous-page' size='sm' hasIconOnly disabled={page === 0} onClick={() => onChange(page - 1)} />
            <span className='mx-2'>
                Page {page + 1} / {numPages}
            </span>
            <Button renderIcon={PageLast} iconDescription='next-page' size='sm' hasIconOnly disabled={page >= numPages - 1} onClick={() => onChange(page + 1)} />
        </div>
    )
}
